import { resolveScrollBehavior } from './reducedMotion';

function scrollToTop() {
    if (typeof window === 'undefined') {
        return;
    }
    window.scrollTo({ top: 0, behavior: resolveScrollBehavior() });
}

export default scrollToTop;
